import React, { useEffect } from 'react';
import { Form, FormGroup, Input, Row } from 'reactstrap';
import { CustomForm } from 'components/Generic/CustomForm';
import { Text } from 'components/Form/Fields';
import { handleSendGeneric } from 'services/generic';
import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { convertToFloat } from 'utility/generic';
import { convertBrl } from 'utility/generic';
import { TableGeneric } from './sales';
import { useState } from 'react';

const toRedirect = '/admin/sales';

export const SaleSuccessScreenForm = () => {
  const { id } = useParams();
  const [products, setProducts] = useState([]);
  const [sale, setSale] = useState({});

  const columnsProduct = useMemo(
    () => [
      {
        Header: 'Nome',
        accessor: 'name',
      },
      {
        Header: 'Valor',
        accessor: 'value',
      },
      {
        Header: 'Quantidade',
        accessor: 'quantity',
      },
      {
        Header: 'Valor Total',
        accessor: (row) =>
          convertBrl((convertToFloat(row.value) * row.quantity).toFixed(2)),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    async function getSaleById() {
      const data = await handleSendGeneric('/v1/sale/' + id, 'GET');
      if (data) {
        const productListConvert = data.productList.map((prod) => {
          return {
            id: prod.id,
            quantity: prod.quantity,
            value: prod.stock.value,
            name: prod.stock.name,
          };
        });
        setProducts(productListConvert);
      }
    }
    getSaleById();
  }, [id]);

  return (
    <>
      <CustomForm
        nameForm={'Pré-Venda'}
        typeForm={'POST'}
        pathUrl={'/v1/sale'}
        toRedirect={toRedirect}
        getValues={sale}
        loadValues={setSale}
        forceRefreshPage
        onlyReturnPage
      >
        <Form>
          <div className='pl-lg-4'>
            <Row>
              <Text
                label={'Razão Social'}
                fieldName={'client.name'}
                placeholder={'Informe a razão social'}
                size={4}
                readOnly={true}
                value={sale?.client?.name}
              />
              <Text
                fieldName={'client.commission'}
                label={'Comissão'}
                placeholder={'Informe a comissão do cliente'}
                size={2}
                readOnly={true}
                value={sale?.client?.commission}
              />
              <Text
                label={'Cidade'}
                placeholder={''}
                fieldName={'client.city'}
                size={4}
                readOnly={true}
                value={sale?.client?.city}
              />
            </Row>
            <TableGeneric
              columns={columnsProduct}
              data={products}
              disableGlobalFilter={true} //TODO: Atualizar mensagem quando não estiver nada cadastrado.
            />
            <FormGroup>
              <label
                style={{ marginTop: '20px' }}
                className='form-control-label'
                htmlFor='input-first-name'
              >
                Total
              </label>
              <Input
                className='form-control-alternative'
                id='input-first-name'
                size={'lg'}
                type='text'
                value={convertBrl(
                  products.reduce(
                    (sum, product) =>
                      sum + convertToFloat(product.value) * product.quantity,
                    0
                  )
                )}
                readOnly={true}
              />
            </FormGroup>
          </div>
        </Form>
      </CustomForm>
    </>
  );
};
